import { FC } from 'react';

import { LazyLoadedPlayer } from '@rikstv/play-player/src/LazyLoadedPlayer';
import { Loader } from '@rikstv/shared-components';

import { Channel } from '../../forces/channels/channel.types';
import { useAuthToken } from '../../hooks/useAuthToken';

import { PlayerDialogues } from './coverpage.types';
import { useIsUnsupported } from './useIsUnsupported';

interface OwnProps {
  channel: Channel;
  posterUrl: string;
}

type Props = OwnProps & PlayerDialogues;

export const PlaybackLive: FC<Props> = ({
  noAccessDialogue: NoAccessDialogue,
  signupDialogue: SignupDialogue,
  channel,
  posterUrl,
}) => {
  const token = useAuthToken();
  const Unsupported = useIsUnsupported();

  if (channel === undefined) {
    return <Loader size="large" />;
  }

  if (!token) {
    return <SignupDialogue posterUrl={posterUrl} assetOrChannel={channel} />;
  }

  if (channel && !channel.isInSubscription) {
    return <NoAccessDialogue channelId={channel.originChannel.channelId} posterUrl={posterUrl} />;
  }

  if (Unsupported !== null) {
    return <Unsupported />;
  }

  return <LazyLoadedPlayer playable={channel} posterUrl={posterUrl} onPlayNextReady={undefined} />;
};
